"use client";

import { FaFacebookF, FaInstagram } from "react-icons/fa";

type StoreFloatingSocialsProps = {
  instagram?: string | null;
  facebook?: string | null;
};

export default function StoreFloatingSocials({
  instagram,
  facebook,
}: StoreFloatingSocialsProps) {
  const socials = [
    {
      label: "Instagram",
      href: instagram,
      Icon: FaInstagram,
      color:
        "bg-gradient-to-br from-purple-600 via-pink-500 to-orange-400",
    },
    {
      label: "Facebook",
      href: facebook,
      Icon: FaFacebookF,
      color: "bg-[#1877F2]",
    },
  ].filter(
    (social): social is typeof social & { href: string } =>
      Boolean(social.href?.trim()),
  );

  if (socials.length === 0) {
    return null;
  }

  const links = socials.map(({ label, href, Icon, color }) => (
    <a
      key={label}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Visitar ${label} da empresa`}
      title={label}
      className={`flex h-10 w-10 items-center justify-center rounded-lg text-white shadow-sm transition-transform duration-200 hover:scale-110 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 ${color}`}
    >
      <Icon size={18} aria-hidden="true" />
    </a>
  ));

  return (
    <>
      {/* Desktop */}
      <aside
        aria-label="Redes sociais da empresa"
        className="fixed left-3 top-1/2 z-30 hidden -translate-y-1/2 flex-col gap-2 rounded-xl bg-white p-2 shadow-lg ring-1 ring-slate-200 md:flex"
      >
        {links}
      </aside>

    </>
  );
}
